"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorage_1 = __importDefault(require("../services/LocalStorage"));
var getExpirationInLocalStorage = function (cookieName) {
    var expirationDateStr = LocalStorage_1.default.getItem(cookieName + "-expiration");
    if (expirationDateStr) {
        var date = new Date(expirationDateStr);
        return Number.isNaN(date.getTime()) ? null : date;
    }
    return null;
};
exports.default = getExpirationInLocalStorage;
